import styled from 'styled-components';

export const StartEnjoyingButtonStyles = styled.button`
  width: 100%;
  height: 56px;
  background: linear-gradient(180deg, #a77aff 0%, #6d2ceb 100%);
  border: none;
  border-radius: 12px;
  color: white;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin: 20px 0;
  padding: 0 24px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(109, 44, 235, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(109, 44, 235, 0.3);
  }
`;
